import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewLink = _resolveComponent("PreviewLink")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_FormDetailModal = _resolveComponent("FormDetailModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      defaultFilter: _ctx.defaultFilter,
      tableFilter: _ctx.tableFilter,
      bulkDelete: _ctx.bulkDelete,
      viewName: _ctx.viewName,
      tableForm: _ctx.formData,
      "onUpdate:tableForm": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData) = $event)),
      addButtonText: `${_ctx.t('pages.event.assignForm')}`,
      onQueryUpdate: _ctx.syncQuery,
      onFormSubmit: _ctx.submit,
      onBulkDelete: _ctx.onBulkDelete,
      permissions: _ctx.permissionModel,
      ref: "Datatable"
    }, {
      "cell-name": _withCtx(({ row: event }) => [
        _createTextVNode(_toDisplayString(event.name) + " ", 1),
        _createVNode(_component_PreviewLink, {
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          routerName: {
          name: 'detail.form',
          params: { id: event.webId },
        }
        }, null, 8, ["routerName"])
      ]),
      "cell-assignDate": _withCtx(({ row: event }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.format.DateTime(event.assignDate)), 1)
      ]),
      "cell-status": _withCtx(({ row: event }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success': event.status?.toLowerCase() === 'active',

          'badge badge-danger': event.status?.toLowerCase() !== 'active',
        }])
        }, _toDisplayString(_ctx.format.TitleCase(event.status?.toLowerCase())), 3)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "bulkDelete", "viewName", "tableForm", "addButtonText", "onQueryUpdate", "onFormSubmit", "onBulkDelete", "permissions"]),
    _createVNode(_component_FormDetailModal, {
      viewName: "form_detail_modal",
      data: _ctx.selectedForm,
      loading: _ctx.formDetailLoader,
      showDialog: _ctx.showDetailDialog,
      onCloseDetail: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDetailDialog = false))
    }, null, 8, ["data", "loading", "showDialog"])
  ], 64))
}